module.exports = __webpack_public_path__ + "static/media/IMG_20161024_211539_edited.6b270d76.jpg";